export default {
  en: {
    empty: 'Drag and drop your contents'
  },
};
